import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.ShadeFilter,
    dependencies: [
    ]
})
export class ShadeFilter {
    constructor() {
        return ((shadeEnumValue: string, colorName: string) => {
            let shadeNum: number = 50;
            if (shadeEnumValue.startsWith("lighter")) {
                shadeNum = Number(shadeEnumValue.substr(7)) * 10;
            } else if (shadeEnumValue.startsWith("darker")) {
                shadeNum = (Number(shadeEnumValue.substr(6)) * 10) + 50;
            }
            let prefix = "kb-background";
            return `${prefix}--${colorName.toLowerCase()}-${shadeNum}`;
        }) as any;
    }
}
